import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin( SplitText );
gsap.registerPlugin( CustomEase );

export function useSplitText2 ( elRef, options = {
	type: 'chars',
	splitClass: 'inline-block',
	isAutoRevert: true,
} ) {

	const { locale } = useI18n();
	const splitInstance = ref( null );
	const targets = computed( () => {
		return splitInstance.value?.chars.filter(
			el => !el.hasAttribute( 'data-static' )
		);
	} );

	let animation, revertAnimation;

	const init = () => {
		splitInstance.value = new SplitText( elRef.value, {
			type: options.type || 'chars',
			mask: 'chars',
			aria: "none",
			smartWrap: locale.value === 'en' ? true : false,
			linesClass: options.splitClass || 'inline-block',
			wordsClass: options.splitClass || 'inline-block',
			charsClass: options.splitClass || 'inline-block',
			onSplit: () => {
				elRef.value.style.whiteSpace = 'pre-line';
			}
		} );
	};

	const set = () => {
		if ( targets.value )
			gsap.to( targets.value, {
				yPercent: 100,
				duration: 0.8,
				ease: "linear",
			} );
	};

	const animate = ( gsapOptions = {} ) => {

		if ( !elRef.value || !splitInstance.value || !targets.value ) return;

		if ( revertAnimation ) {
			revertAnimation.pause();
		}

		animation = gsap.fromTo( targets.value,
			{
				yPercent: 100,
			},
			{
				yPercent: 0,
				duration: 0.8,
				stagger: 0.05,
				ease: CustomEase.create( "custom", "M0,0 C0.272,0 0.41,0.692 0.442,0.817 0.494,1.022 0.744,1 1,1 " ),
				...gsapOptions,
				// 預設 revert() 在動畫完成時
				onComplete: () => {
					if ( options.isAutoRevert ) splitInstance.value?.revert();
				}
			}
		);
	};

	const revert = () => {
		if ( !targets.value ) return;

		revertAnimation = gsap.to( targets.value, {
			yPercent: -100,
			duration: 0.8,
			stagger: 0.05,
			ease: CustomEase.create( "custom", "M0,0 C0.272,0 0.41,0.692 0.442,0.817 0.494,1.022 0.744,1 1,1 " ),
		} );
	};

	onMounted( () => {
		init();
		set();
	} );

	onBeforeUnmount( () => {
		revert();
		if ( splitInstance.value ) {
			splitInstance.value.revert();
			splitInstance.value = null;
		}
	} );

	return {
		animate,
		revert,
		set
	};
}
